import React from 'react';
import '../../Home/Banner/styles/index.css';
import { withTranslation, Trans } from 'react-i18next';
import RegionalsButton from '../../ui/Button/regionalsButtons';
import SiteButton from '../../ui/Button/siteButtons';

const Banner = ({ cloudFront, history, t, bannerJffLink }) => (
  <section className="banner-container">
    <div className="piller mx-auto">
      <div className="homepage-banner-content">
        <h1 className="darkTxt weight-500">
          {t('translations.bannerTitleStart')}{' '}
          <span className="d-inline-block homepage-special-text weight-600" style={{ lineHeight: '1.9', fontSize: '0.85em' }}>
            {t('translations.bannerSpecialTitle')}
          </span>{' '}
          {t('translations.bannerTitleEnd')}
        </h1>
        <p className="banner-subtitle d-none d-md-block" style={{ paddingBottom: '25px' }}>
          {t('translations.bannerDescription')}
        </p>
        {/* <p id="description">Learn programming, data structures & algorithms, and prepare for the interview - all in one place.</p> */}
        <SiteButton bannerBtn onClick={() => history.push(bannerJffLink)}>
          Join for free
        </SiteButton>
      </div>
      <div className="homepage-banner-video-container">
        <div className="embed-responsive embed-responsive-16by9 homepage-banner-video">
          <object className="no-pointers" data={cloudFront + '/Assets/homePage/HomePageBannerNew.svg'}>
            Banner image
          </object>
        </div>
      </div>
    </div>
  </section>
);

export default withTranslation('translations')(Banner);
